(function () {
  var WIDGET_SELECTOR = ".rebuy-recommendations-widget";
  var SLIDER_SELECTOR = ".rebuy-recommendations-slider";
  // Captured now: currentScript is only set while this file is first executing.
  var currentScript = document.currentScript;

  function isId(value) {
    return /^\d+$/.test(value);
  }

  function fillCustomerName(root, customerName) {
    root.querySelectorAll("[data-customer-name]").forEach(function (nameEl) {
      if (customerName) {
        nameEl.textContent = customerName;
        nameEl.removeAttribute("data-customer-name");
        return;
      }

      // No name, so drop the placeholder and tidy the gap: "Hi [name], picks" -> "Hi, picks".
      var prev = nameEl.previousSibling;
      var next = nameEl.nextSibling;
      var nextText = next && next.nodeType === 3 ? next.nodeValue : "";

      nameEl.remove();

      if (prev && prev.nodeType === 3) {
        if (!next || /^[\s,.!?;:]/.test(nextText))
          prev.nodeValue = prev.nodeValue.replace(/\s+$/, "");
      } else if (!prev && nextText) {
        next.nodeValue = nextText.replace(/^[\s,;:]+/, "");
      }
    });
  }

  function applyUrlParams(widgetId) {
    if (!widgetId) return;

    var params = new URLSearchParams(window.location.search);

    function param(name) {
      return (params.get(name) || "").trim();
    }

    var customerId = param("customer_id");
    var orderId = param("order_id");
    var productIds = param("product_ids")
      .split(",")
      .map(function (id) {
        return id.trim();
      })
      .filter(isId);
    var widgetSelector =
      '[data-rebuy-id="' +
      CSS.escape(widgetId) +
      '"][data-product-data-source]';

    document.querySelectorAll(widgetSelector).forEach(function (widget) {
      var source = widget.dataset.productDataSource;

      if (source === "customer_previous_order" || source === "customer_only") {
        // Rebuy ignores a customer data attribute; its identity reads window.Rebuy.customer.id first.
        if (isId(customerId)) {
          window.Rebuy = window.Rebuy || {};
          window.Rebuy.customer = window.Rebuy.customer || {};
          window.Rebuy.customer.id = Number(customerId);
        }
      }

      if (source === "customer_previous_order") {
        if (isId(orderId)) {
          widget.setAttribute("data-rebuy-shopify-order-id", orderId);
          widget.setAttribute("shopify_order_id", orderId);
        }
        if (productIds.length)
          widget.setAttribute(
            "data-rebuy-shopify-product-ids",
            productIds.join(","),
          );
      }

      var section = widget.closest(".rebuy-recommendations");
      if (section) fillCustomerName(section, param("customer_name"));
    });
  }

  // Runs straight away, not on DOMContentLoaded, so the attributes are set before Rebuy reads them.
  applyUrlParams(currentScript && currentScript.dataset.widgetId);

  if (window.rebuyRecommendationsInitialized) return;
  window.rebuyRecommendationsInitialized = true;

  var loadingStages = new WeakMap();

  function updateLoadingStates() {
    document.querySelectorAll(".rebuy-recommendations__stage").forEach(function (stage) {
      if (stage.dataset.recommendationsState === "ready" ||
          stage.dataset.recommendationsState === "empty") return;

      var state = loadingStages.get(stage);
      if (!state) {
        state = { waiting: false };
        loadingStages.set(stage, state);
      }

      var slider = stage.querySelector(SLIDER_SELECTOR);
      var widget = stage.querySelector(WIDGET_SELECTOR);
      if (state.waiting || !slider || !slider.swiper || !widget ||
          widget.hasAttribute("v-cloak") || !widget.classList.contains("is-visible") ||
          !slider.querySelector(".swiper-slide")) return;

      state.waiting = true;
      var images = Array.from(slider.querySelectorAll(".swiper-slide img")).slice(0, 4);
      Promise.all(images.map(function (image) {
        return new Promise(function (resolve) {
          if (image.complete) return resolve();
          image.addEventListener("load", resolve, { once: true });
          image.addEventListener("error", resolve, { once: true });
          image.loading = "eager";
        });
      })).then(function () {
        if (!stage.isConnected || loadingStages.get(stage) !== state) return;
        slider.swiper.update();
        requestAnimationFrame(function () {
          if (!stage.isConnected || loadingStages.get(stage) !== state) return;
          stage.dataset.recommendationsState = "ready";
          stage.setAttribute("aria-busy", "false");
          stage.querySelector(".rebuy-recommendations__status").hidden = true;
          stage.querySelector("[data-rebuy-id]").removeAttribute("inert");
        });
      });
    });
  }

  function handleRecommendationResponse(event) {
    var detail = event.detail || {};
    var widget = detail.widget;
    if (!widget || widget.id == null) return;

    var products = Array.isArray(detail.products)
      ? detail.products
      : widget.data && widget.data.products;
    if (!Array.isArray(products)) return;

    var selector = '[data-rebuy-id="' + CSS.escape(String(widget.id)) + '"][data-product-data-source]';
    document.querySelectorAll(selector).forEach(function (host) {
      var stage = host.closest(".rebuy-recommendations__stage");
      var section = host.closest(".rebuy-recommendations");
      if (!stage || !section) return;

      var empty = products.length === 0;
      section.hidden = empty;
      if (empty) {
        loadingStages.delete(stage);
        stage.dataset.recommendationsState = "empty";
        stage.setAttribute("aria-busy", "false");
        stage.querySelector(".rebuy-recommendations__status").hidden = true;
        host.setAttribute("inert", "");
      } else if (stage.dataset.recommendationsState === "empty") {
        stage.dataset.recommendationsState = "loading";
        stage.setAttribute("aria-busy", "true");
        stage.querySelector(".rebuy-recommendations__status").hidden = false;
      }
    });

    requestAnimationFrame(function () { init(document); });
  }

  document.addEventListener("rebuy.ready", handleRecommendationResponse);
  document.addEventListener("rebuy.productsChange", handleRecommendationResponse);

  function getBadgeConfig() {
    var configEl = document.getElementById(
      "rebuy-recommendations-badge-config",
    );
    if (!configEl) return null;

    try {
      return JSON.parse(configEl.textContent);
    } catch (error) {
      return null;
    }
  }

  function handleize(value) {
    return String(value || "")
      .toLowerCase()
      .trim()
      .replace(/['"]/g, "")
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-+|-+$/g, "");
  }

  function escapeHtml(value) {
    return String(value || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;");
  }

  function normalizeTags(value) {
    if (Array.isArray(value)) {
      return value
        .map(function (tag) {
          return String(tag).trim();
        })
        .filter(Boolean);
    }

    return String(value || "")
      .split(/\|\||,/)
      .map(function (tag) {
        return tag.trim();
      })
      .filter(Boolean);
  }

  function buildBadgeHtml(label, extraClass, styles, colorScheme) {
    var styleAttr = "";
    var className = "Card_product_media_customtags_innerloops_innerboxs_new";

    if (colorScheme) {
      className += " color-" + colorScheme;
    }

    if (extraClass) {
      className += " " + extraClass;
    }

    if (styles && (styles.background || styles.color)) {
      styleAttr =
        ' style="' +
        (styles.background
          ? "background: " + escapeHtml(styles.background) + ";"
          : "") +
        (styles.color ? " color: " + escapeHtml(styles.color) + ";" : "") +
        '"';
    }

    return (
      '<div class="Card_product_media_customtags_innerloops_mainboxs_new"><div class="' +
      className +
      '"' +
      styleAttr +
      ">" +
      escapeHtml(label) +
      "</div></div>"
    );
  }

  function buildSaveBadge(price, compareAtPrice, available, config) {
    var currentPrice = Number(price || 0);
    var comparePrice = Number(compareAtPrice || 0);

    if (!available || !(comparePrice > currentPrice && currentPrice > 0))
      return "";

    var content = "";
    var styleAttr = "";

    if (config.showDiscountPercentage) {
      var discountPercent = Math.round(
        ((comparePrice - currentPrice) * 100) / comparePrice,
      );
      content = "save " + discountPercent + "%";
      styleAttr =
        ' style="background:' +
        escapeHtml(config.showDiscountPercentageBackground || "") +
        "; color:" +
        escapeHtml(config.showDiscountPercentageText || "") +
        ';"';
    } else {
      var savingAmount = ((comparePrice - currentPrice) / 100).toLocaleString(
        "en-GB",
        {
          style: "currency",
          currency:
            (window.Shopify && Shopify.currency && Shopify.currency.active) ||
            "GBP",
        },
      );
      content = "save " + savingAmount;
    }

    return (
      '<div class="Card_product_media_customtags_innerloops_mainboxs_new"><div class="Card_product_media_customtags_innerloops_innerboxs_new save_price_new"' +
      styleAttr +
      ">" +
      escapeHtml(content) +
      "</div></div>"
    );
  }

  function renderBadges(root) {
    var scope = root && root.nodeType === 1 ? root : document;
    var config = getBadgeConfig();

    if (!config) return;

    scope
      .querySelectorAll(WIDGET_SELECTOR + " .card__badge[data-product-tags]")
      .forEach(function (badgeEl) {
        var tags = normalizeTags(badgeEl.dataset.productTags);
        var templateSuffix = badgeEl.dataset.templateSuffix || "";
        var available = badgeEl.dataset.available === "true";
        var customLabels = tags
          .filter(function (tag) {
            return tag.indexOf("_label_") !== -1 && tag.charAt(0) === "_";
          })
          .map(function (tag) {
            return tag.replace("_label_", "");
          })
          .filter(function (tag) {
            return handleize(tag) !== handleize(config.soldOutLabel);
          });
        var html = "";

        function appendCustomLabels() {
          customLabels.forEach(function (label) {
            var styles = config.tagStyles[handleize(label)] || {};
            var extraClass =
              handleize(label) === handleize(config.soldOutLabel)
                ? "sold-out-tag"
                : "";
            html += buildBadgeHtml(
              label,
              extraClass,
              styles,
              config.saleBadgeColorScheme,
            );
          });
        }

        if (templateSuffix === "bridesmaid-pouch") {
          if (customLabels.length) {
            appendCustomLabels();
          } else if (!available) {
            html += buildBadgeHtml(
              config.soldOutLabel,
              "",
              config.tagStyles[handleize(config.soldOutLabel)] || {},
              config.saleBadgeColorScheme,
            );
          }
        }

        html += buildSaveBadge(
          badgeEl.dataset.price,
          badgeEl.dataset.compareAtPrice,
          available,
          config,
        );

        if (templateSuffix !== "bridesmaid-pouch") {
          if (customLabels.length) {
            appendCustomLabels();
          } else if (!available) {
            html += buildBadgeHtml(
              config.soldOutLabel,
              "",
              config.tagStyles[handleize(config.soldOutLabel)] || {},
              config.saleBadgeColorScheme,
            );
          }
        }

        badgeEl.innerHTML = html;
        badgeEl.style.display = html ? "flex" : "none";
      });
  }

  function initCarousel(root) {
    if (typeof Swiper === "undefined") return;

    var scope = root && root.nodeType === 1 ? root : document;

    var sliders = Array.from(scope.querySelectorAll(SLIDER_SELECTOR));
    if (scope.matches && scope.matches(SLIDER_SELECTOR)) sliders.unshift(scope);
    sliders.forEach(function (sliderElement) {
      if (sliderElement.swiper) return;

      var navId = sliderElement.dataset.sliderId;
      // A lone card would be squeezed to the 2-up width on mobile, so widen it.
      var slideCount = sliderElement.querySelectorAll(".swiper-slide").length;

      new Swiper(sliderElement, {
        loop: false,
        grabCursor: true,
        spaceBetween: 26,
        slidesPerGroup: 1,
        slidesPerView: 4,
        watchSlidesProgress: true,
        watchOverflow: true,
        centerInsufficientSlides: true,
        threshold: 10,
        navigation: {
          nextEl: '.swiper-button-next[data-nav-id="' + navId + '"]',
          prevEl: '.swiper-button-prev[data-nav-id="' + navId + '"]',
        },
        breakpoints: {
          0: {
            slidesPerView: slideCount === 1 ? 1.25 : 2,
            spaceBetween: 9,
          },
          750: {
            slidesPerView: 3,
            spaceBetween: 13,
          },
          990: {
            slidesPerView: 4,
            spaceBetween: 26,
          },
        },
      });
    });
  }

  function init(root) {
    initCarousel(root);
    renderBadges(root);
    updateLoadingStates();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      init(document);
    });
  } else {
    init(document);
  }

  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        init(node);
      });
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });

  var loadingObserver = new MutationObserver(updateLoadingStates);
  loadingObserver.observe(document.body, {
    attributes: true,
    attributeFilter: ["class", "v-cloak"],
    subtree: true,
  });

  var loadingPoll = setInterval(function () {
    initCarousel(document);
    updateLoadingStates();
    if (!document.querySelector('[data-recommendations-state="loading"]')) {
      clearInterval(loadingPoll);
    }
  }, 250);
})();
